import updateCart from "../util/updateCart";
import { blockEl, unblockEl } from "./Block";
import popup from "./Popup";

const { __ } = wp.i18n;

export default class Cart {
  constructor() {
    if ( typeof palram.checkout_params === 'undefined' || typeof palram.cart_params === 'undefined' ) {
      return false;
    }

    this.updateTimer = false;
    this.finally = null;

    this.addHandlers();
  }

  addHandlers() {
    $( document.body ).on( 'removed_from_cart', this.checkoutRemovedFromCartHandler.bind( this ) );
    $( document.body ).on( 'click', '.btn-coupon-code', this.appliedCoupon.bind( this ) );
    $( document.body ).on( 'click', 'a.woocommerce-remove-coupon', this.removeCoupon.bind( this ) );
    $( document.body ).on( 'click', 'input#coupon_code', this.clearMessages.bind( this ) );
  }

  checkoutRemovedFromCartHandler() {
    if ( ! palram.checkout_params.is_checkout ) {
      return;
    }

    $( document.body ).trigger( 'update_checkout' );
  }

  appliedCoupon( event ) {
    if ( ! $( 'input[name=coupon_code]' ) ) {
      return;
    }
    event.preventDefault();
    this.$text_field = $( '#coupon_code' );
    this.coupon_code = this.$text_field.val();
    if ( palram.is_cart ) {
      this.form = document.querySelector( 'form.woocommerce-cart-form' );
    }

    if ( palram.checkout_params.is_checkout ) {
      this.form = document.querySelector( 'form.checkout' );
    }

    blockEl( this.form );

    const data = {
      action : 'palram_apply_coupon',
      secure : palram.cart_params.apply_coupon_nonce,
      coupon_code : this.coupon_code,
    };

    this.setCouponRequest( data )
      .fail( this.appliedCouponFail.bind( this ) )
      .done( this.appliedCouponSuccess.bind( this ) )
      .always( () => {
        unblockEl( this.form );
        this.resetUpdateTimer();
        this.updateTimer = setTimeout( this.updateForms.bind( this ), 2500 );
      } );
  }

  removeCoupon( event ) {
    event.preventDefault();
    this.coupon = $( event.currentTarget ).attr( 'data-coupon' );
    if ( palram.is_cart ) {
      this.form = document.querySelector( 'form.woocommerce-cart-form' );
    }

    if ( palram.checkout_params.is_checkout ) {
      this.form = document.querySelector( 'form.checkout' );
    }

    blockEl( this.form );
    const data = {
      action : 'palram_remove_coupon',
      secure : palram.cart_params.remove_coupon_nonce,
      coupon : this.coupon,
    };

    this.setCouponRequest( data )
      .fail( this.appliedCouponFail.bind( this ) )
      .done( this.removeCouponSuccess.bind( this ) )
      .always( () => {
        unblockEl( this.form );
        this.resetUpdateTimer();
        this.updateTimer = setTimeout( this.updateForms.bind( this ), 2500 );
      } );
  }

  appliedCouponSuccess( response ) {
    this.clearMessages();
    this.getCouponNotice( response.notice );
    $( document.body ).trigger( 'applied_coupon', [ this.coupon_code ] );
  }

  removeCouponSuccess( response ) {
    const $couponDiscountWrap = $( '.coupon-discount-wrap' );
    this.clearMessages();
    this.getCouponNotice( response.notice );

    if ( $couponDiscountWrap ) {
      $couponDiscountWrap.hide();
      $couponDiscountWrap.removeClass( 'd-flex' );
    }

    $( document.body ).trigger( 'remove_coupon', [ this.coupon ] );
  }

  appliedCouponFail() {
    popup.open( {
      title : __( 'Oh no...', 'canopia' ),
      type : 'warning',
      message : __( 'An error has occurred.', 'canopia' ),
      close : {
        text : __( 'Try again', 'canopia' ),
      },
    } );
  }

  getCouponNotice( notices ) {
    if ( this.form.classList.contains( '.element-blocked' ) ) {
      return;
    }

    let message = '';
    let inputWrap = document.querySelector( '.coupon-input-wrap' );
    for( let notice of notices ) {
      message = notice;
    }

    let wcMessage = `<span class="woocommerce-error fs-14 text-carmine position-absolute start-0 top-100">${ message }</span>`;
    inputWrap.insertAdjacentHTML( "beforeend", wcMessage );
  }

  updateForms() {
    if ( palram.is_cart ) {
      updateCart();
    }

    if ( palram.checkout_params.is_checkout ) {
      $( document.body ).trigger( 'update_checkout' );
    }
  }

  clearMessages() {
    let $messages = $( '.woocommerce-error, .woocommerce-message' );
    if ( ! $messages ) {
      return;
    }

    $messages.remove();
  }

  resetUpdateTimer() {
    clearTimeout( this.updateTimer );
  }

  setCouponRequest( data ) {
    return $.ajax( {
      type : 'POST',
      url : palram.ajax_url,
      dataType : 'json',
      data,
    } );
  }
}
